import { defineMessages } from 'react-intl';

export default defineMessages({
  readonlyDimensions: {
    description: 'The dimension values of a package, Length, Width, and Height',
    defaultMessage: '{length} x {width} x {height}',
    id: 'PJFJ8T',
  },
  fileAClaim: {
    description: 'Fulfillment Planner File a Claim Label',
    defaultMessage: 'File a Claim',
    id: 'Ke522j',
  },
});
